import React from 'react';

function Header() {
	return (
		<header>
			<h1>Quizzical</h1>
		</header>
	);
}

export default Header;
